
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.56 14.587l9.334-9.334a2.003 2.003 0 012.827 2.84l-5.907 5.894h15.213a2 2 0 110 4H10.814l5.907 5.893a2 2 0 01-1.414 3.413 1.973 1.973 0 01-1.413-.626l-9.333-9.334a2 2 0 010-2.826v.08z","fill":"#585858"}})])
          )
        }
      }
    